import i18n from 'i18next'
import {format} from 'ag-common/facades'
import {orderBy, values, groupBy} from 'lodash'

export function transformToRowAzubi(azubis) {
  return azubis.map(azubi => {
    return {
      ...azubi,
      fullname: `${azubi.lastname} ${azubi.firstname}`,
      nameFormatted: `${azubi.lastname} ${azubi.firstname}`,
      ausbildungsberufFormatted: azubi.ausbildungsBerufString,
      ausbildungsstartDate: new Date(azubi.ausbildungsstart),
      ausbildungsstartFormatted: format(new Date(azubi.ausbildungsstart), 'dd.MM.yyyy'),
      ausbildungsJahrFormatted: i18n.t('meineazubis_ausbildungsjahr', [azubi.ausbildungsjahr]),
      ausbildungsnachweisTypFormatted: i18n.t(azubi.ausbildungsnachweisTyp),
      marktFormatted: azubi.markt,
      isViewable: undefined,
    }
  })
}

export function sortAzubis(sortOptions, transformedAzubis) {
  if (sortOptions.sortType === 'aufsteigend') {
    return orderBy(transformedAzubis, `${sortOptions.filterType}Formatted`, 'asc')
  }
  if (sortOptions.sortType === 'absteigend') {
    return orderBy(transformedAzubis, `${sortOptions.filterType}Formatted`, 'desc')
  }
  return transformedAzubis
}

export function filterAzubis(sortedAzubiList, filterRules) {
  if (filterRules === undefined || filterRules.length === 0) return sortedAzubiList
  const azubiList = sortedAzubiList
  const groupedRules = values(groupBy(filterRules, 'type'))

  return azubiList
    .map(azubi => {
      let rulesMet = 0
      groupedRules.forEach(rulegroup => {
        rulegroup.forEach(rule => {
          if (azubi[`${rule.type}Formatted`] === rule.rule) {
            // eslint-disable-next-line no-plusplus
            rulesMet++
          }
        })
      })
      if (rulesMet >= groupedRules.length) {
        return {...azubi, isViewable: true}
      }
      return undefined
    })
    .filter(azubi => azubi !== undefined && azubi.isViewable)
}
